const Api = (opt) => {
  // 
  // ─── CREATION DU HEADER NECESSAIRE A LA REQUETE ───────────────────────────────────────
  //
  let myHeaders = new Headers();
  if (!opt.removeHeader) {
    myHeaders.append("Content-Type", "application/json");
  }


  const auth = localStorage.getItem('saint_bernard_auth')
  // 
  // ─── AJOUT DU TOKEN DANS LE HEADER S'IL EST RENSEIGNE ───────────────────────────────────────
  //
  if (auth) {
    myHeaders.append('Authorization', `Bearer ${JSON.parse(auth).token || ''}`);
  }

  // 
  // ─── DEFINITION DE LA METHODE A UTILISER ───────────────────────────────────────
  //
  let method = opt.method || 'POST'

  // 
  // ─── AJOUT DES OPTIONS DANS LE HEADER ───────────────────────────────────────
  //
  let requestOptions = {
    method,
    headers: myHeaders,
    redirect: 'follow'
  }

  // 
  // ─── AJOUT DES DONNEES SOUS FORME DE JSON STRINGIFY ───────────────────────────────────────
  //
  if (['POST', 'PUT', 'DELETE'].includes(method)) {

    const data = opt.data

    if (auth) {
      if (opt.removeHeader) {
        data.append('user_id', JSON.parse(auth).user_id)
      } else {
        data['user_id'] = JSON.parse(auth).user_id;
      }
    }

    requestOptions = { ...requestOptions, body: opt.removeHeader ? data : JSON.stringify(data) }
  }

  // 
  // ─── REQUETE A L'API ───────────────────────────────────────
  //
  return fetch(`${process.env.REACT_APP_API_URL}${opt.endpoint}`, requestOptions)
    .then(response => response.json())
    .then(result => result)
    .catch(error => console.log('error', error));
}

export default Api;